
   document.addEventListener("DOMContentLoaded", function () {
    // Select all sets of tabs with the class "main_tab_row"
    const tabSets = document.querySelectorAll(".main_tab_row");

    // Loop through each tab set
    tabSets.forEach(function (tabSet) {
      if (window.matchMedia("(min-width: 768px)").matches) {
        const customTab = tabSet.querySelector(".custom_tab");
        const tabTitles = customTab.querySelector(".tab_titles");

        const activeBar = document.createElement("div");
        activeBar.className = "active_bar";

        tabTitles.appendChild(activeBar);
      }

      const tabTitles = tabSet.querySelectorAll(".tab_title");
      const tabContents = tabSet.querySelectorAll(".tab_content");
      const activeBar = tabSet.querySelector(".active_bar");

      function setActiveTab(index) {
        // Remove 'active' class from all tab titles
        tabTitles.forEach(function (tabTitle) {
          tabTitle.classList.remove("active");
        });

        // Add 'active' class to the clicked tab title
        tabTitles[index].classList.add("active");

        // Hide all tab contents
        tabContents.forEach(function (content) {
          content.classList.remove("show");
        });

        // Show the tab content corresponding to the clicked item
        tabContents[index].classList.add("show");

        // Calculate the width and left position of the active bar
        const activeTabTitle = tabTitles[index];
        const tabWidth = activeTabTitle.offsetWidth;
        const tabLeft =
          activeTabTitle.getBoundingClientRect().left -
          tabTitles[0].parentElement.getBoundingClientRect().left;

        if (window.matchMedia("(min-width: 768px)").matches) {
          // Set the width and left position of the active bar
          activeBar.style.width = tabWidth + "px";
          activeBar.style.left = tabLeft + "px";
        }
      }

      tabTitles.forEach(function (title, index) {
        title.addEventListener("click", function (e) {
          e.preventDefault();
          setActiveTab(index);
        });
      });

      // Trigger the click event on the first tab title by default
      setActiveTab(0);
    });
  });

  // slider for mobile
 function initializeCustomTabSlick() {
  if (window.matchMedia("(max-width: 767px)").matches) {
    // Initialize Slick slider if it's not already initialized
    if ($(".custom_tab .tab_titles").length && !$(".custom_tab .tab_titles").hasClass("slick-initialized")) {
      $(".custom_tab .tab_titles").slick({
        slidesToShow: 1,
        centerMode: true,
        arrows: true,
        infinite: false
      });

      $(".custom_tab .slick-arrow").on("click", function () {
        $(".custom_tab .slick-center").click();
      });
    }
  } else {
    // Destroy Slick slider if it's initialized and window size is greater than 767px
    if ($(".custom_tab .tab_titles").hasClass("slick-initialized")) {
      $(".custom_tab .tab_titles").slick("unslick");
    }
  }
}

// Initialize on page load
initializeCustomTabSlick();

// Add a resize event listener to reinitialize or remove the slider on window resize
$(window).resize(initializeCustomTabSlick);
